import React, { Component, Fragment } from 'react';

import introducing from '../../assets/introducing.png';

import { getFanzones } from './service';
import './FanZone.css';
import AnchorFanzone from './AnchorFanzone';


class FanZone extends Component {
  constructor(...args) {
    super(...args);

    this.state = { fanzones: [] };
  }

  async componentDidMount() {
    document.title = 'Fan Zones | Naked News';
    const { data: response } = await getFanzones();
    this.setState({ fanzones: response.data });
  }

  render() {
    const { fanzones } = this.state;

    return (
      <Fragment>
        <div className="splash">
          <div className="fanZoneContainer">
            <img alt="introducing" src={introducing} />
            <h1 className="fanZonesTitle">Fan Zones</h1>
            <div className="closer">
              Now you can get even closer to your favorite anchors!
            </div>
            <div className="fanZoneDesc">
              For a low monthly subscription, you can get access to special
              content like Videos and Galleries, as well as the ability to watch
              Live Streams, Chat and privately message our Anchors.
            </div>
          </div>
        </div>
        <AnchorFanzone
          fanzones={fanzones}
          isDiscountPage={false}
        />
      </Fragment>
    );
  }
}

export default FanZone;
